import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=b9c1a5a4&scoped=true"
import script from "./TemplatePreview.vue?vue&type=script&lang=js"
export * from "./TemplatePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c1a5a4",
  null
  
)

export default component.exports